import React from 'react';
import config from '../../config';
import { twitterPageURL } from '../../util/urlHelpers';
import { StaticPage, TopbarContainer } from '../../containers';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  ExternalLink,
} from '../../components';

import css from './AboutPage.module.css';
import image from '../../assets/AboutPage/5.jpg';

const AboutPage = () => {
  const { siteInstagramPage, siteFacebookPage } = config;

  // prettier-ignore
  return (
    <StaticPage
      title="About Us"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'AboutPage',
        description: 'About Subler',
        name: 'About page',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer currentPage="AboutPage"/>
        </LayoutWrapperTopbar>

        <LayoutWrapperMain className={css.staticPageWrapper}>
          <h1 className={css.pageTitle}>We're making finding a place to host & play easier!</h1>
          <img className={css.coverImage} src={image} alt="My first ice cream." />

          <div className={css.contentWrapper}>
            <div className={css.contentSide}>
              <p><b>Stay up to date</b> by following us on <ExternalLink href={siteInstagramPage}>Instagram</ExternalLink> and <ExternalLink href={siteFacebookPage}>Facebook</ExternalLink>! </p>
            </div>

            <div className={css.contentMain}>

              <p>Subler is an online marketplace for renting recreational, athletic, and fitness facilities. We're building the most trusted online community that makes it easy for people to book the right space so they can host practice, games and even events! </p>

              <h3 className={css.subtitle}>Facilities:</h3>

              <p>
                We help increase your bookings while also providing the platform tools to help you manage your requests, bookings, and payments for efficiently. From recreational, athletic facilities, to even schools and non-profit organizations (option to list without requiring payment),  you can now list your space in just a few clicks, then start accepting booking requests on your own time and availability! 
              </p>

              <h3 className={css.subtitle}>Athletes, Sports Organizers, & Others Looking To Book:</h3>

              <p>
                We've created the best place to find available recreational, athletic, and fitness facilities in your community. Subler is a marketplace built for athletes (by athletes!) to easily discover, message, book, pay, and connect with the best and most trusted facilities so you can focus on your sport and game, rather then planning. 
              </p>

              <p>
                If you're an Organizer, you've come to the right place and we specialize in helping organizers easily discover, message, book, pay, and connect with the best and most trusted facilities so you can have peace of mind when it comes to planning that big day, game, or event. 
              </p>

              <p>
                Our team is experts at helping find and book the right space, so please reach out to us at any time and let us know your needs to we can help take care of the rest! 
              </p>
            </div>
          </div>
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

export default AboutPage;
